<template>
  <v-flex md6
          offset-md3>
    <form v-on:submit.prevent="validate"
          class="spacing-top">
      <div class="sign-avatar">
        <router-link to="/">
          <img src="/static/img/logo.png"
               alt=""
               class="img-circle"></router-link>
      </div>
      <header v-html="$t('reset_password_tip')"></header>
      <v-text-field :label="$t('reset_password_placeholder')"
                    v-model="password"
                    type="password"
                    required
                    v-validate="{required: true}">
        <small class="text-danger">
          {{ errors.first('password') }}
        </small>
      </v-text-field>
      <v-container>
        <v-layout>
          <v-flex text-xs-right
                  xs12>
            <v-btn :to="{name: 'Login'}"
                   round
                   class="capitalize"
                   color="grey lighten-3">
              {{$t('login_button_back')}}
            </v-btn>
            <v-btn :loading="isLoading"
                   round
                   color="primary"
                   type="submit"
                   class="capitalize"
                   :disabled="isLoading">
              {{ $t('reset_button_send') }}
              <span slot="loader"
                    class="custom-loader">
                <v-icon light>cached</v-icon>
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>

    </form>
  </v-flex>
</template>

<script>
import authService from '@/services/authService';
import store from '@/store';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';
import _ from 'lodash';

export default {
  name: 'ResetPassword',
  components: {},
  data() {
    return {
      disabled: true,
      isLoading: false,
      token: this.$route.query.token,
      username: this.$route.query.username,
      api: this.$route.query.api,
      password: this.password
    };
  },
  methods: {
    validate() {
      this.isLoading = true;
      this.$validator.validateAll().then(async res => {
        if (res) {
          let tokenApiLocation = _.find(store.state.apiLocations, apiLocation => {
            return apiLocation.isoAlpha3 === this.api;
          });
          let params = {
            newPassword: this.password,
            username: this.username,
            token: this.token,
            lang: store.state.langSelected.langWsp
          };
          await authService.resetPassword(tokenApiLocation.apiHost, params, this.requestResetSuccessHandler, this.loginErrorHandler);
        }
      });
    },
    requestResetSuccessHandler(data) {
      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: data[0],
        type: 'accent',
        doNotTranslate: true
      });

      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: 'logining_title',
        type: 'accent',
        doNotTranslate: false
      });

      let params = {
        username: this.username,
        password: this.password
      };

      authService.login(
        params,
        () => {
          this.isLoading = false;
          this.$router.push({ name: 'Dashboard' });
        },
        () => {}
      );
    },
    loginErrorHandler(data) {
      this.isLoading = false;
      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: this.$i18n.t('error_generic'),
        type: 'error',
        doNotTranslate: true
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/login/ResetPassword.vue